<template>
  <ProductCard
    type="TypeA"
    :product="data.product"
    :callouts="data.callouts"
    :use-lifestyle-image="data.useLifestyleImage"
    :show-discount-badge="data.showDiscountBadge"
    :quickview="true"
    :loadMoreProducts="false"
    :new-product-card="true"
  />
</template>

<script setup>
  import ProductCard from '../global/product-card/index.vue';

  defineProps({
    data: {
      type: Object,
      required: true,
    },
  });
</script>
